module.exports = __webpack_public_path__ + "img/Gif_web6.97405840.gif";